import { supabase } from '../../../integrations/supabase/client';

export interface Contact {
    id: string;
    nombre: string;
    correo: string;
    celular: string;
    ultimaInteraccion: string;
    agente: string;
    agente_id: string | null;
    estado: string;
    company?: string;
    value?: string;
    notes?: string;
    tags?: string;
    ia_activa?: boolean;
}

export const getContacts = async (): Promise<Contact[]> => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('Usuario no autenticado');

    const { data, error } = await supabase
        .from('leads')
        .select(`
            id,
            name,
            email,
            numero_telefono,
            telefono_lead,
            company,
            value,
            notes,
            tags,
            ia_activa,
            last_interaction_at,
            assigned_agent_id,
            agents ( nombre )
        `)
        .eq('user_id', user.id)
        .order('last_interaction_at', { ascending: false, nullsFirst: false });

    if (error) {
        console.error('[contactsApi] Error fetching leads:', error);
        throw error;
    }

    return (data || []).map((lead: any) => ({
        id: lead.id,
        nombre: lead.name || 'Sin nombre',
        correo: lead.email || '',
        celular: lead.telefono_lead || lead.numero_telefono || '',
        ultimaInteraccion: lead.last_interaction_at
            ? new Date(lead.last_interaction_at).toLocaleDateString('es-MX', { year: 'numeric', month: 'short', day: 'numeric' })
            : 'Sin interacción',
        agente: lead.agents?.nombre || 'Sin asignar',
        agente_id: lead.assigned_agent_id,
        estado: lead.tags || 'Sin etiqueta',
        company: lead.company || '',
        value: lead.value?.toString() || '',
        notes: lead.notes || '',
        tags: lead.tags || '',
        ia_activa: lead.ia_activa,
    }));
};
